import _ from 'lodash';
import {
    FETCH_MTOKNA_NEWSLETTERS,
    CLEAN_MTOKNA_NEWSLETTERS,
    DELETE_MTOKNA_NEWSLETTER
} from './types';
import { request, __ } from '../functions';

/**
 * Nacitanie sablon.
 *
 * @param {Screen} screen
 * @param {object} options
 */
export const fetchMtoknaNewsletters = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/newsletters', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_NEWSLETTERS, payload: data });
    });
};

export const deleteMtoknaNewsletter = (screen, id) => {
    return dispatch => request(`/mtokna/removeNewsletter/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať newsletter'));
            return;
        }

        screen.showSnackbar('success', __('Newsletter bol zmazaný'));

        dispatch({ type: DELETE_MTOKNA_NEWSLETTER });
    });
};

/**
 * Vycistenie sablon.
 */
export const cleanMtoknaNewsletters = () => ({ type: CLEAN_MTOKNA_NEWSLETTERS });
